
const rankingPositions = [
  {
    value: undefined,
    label: 'None',
  },
  {
    value: '1',
    label: 'จ.ต.',
  },
  {
    value: '2',
    label: 'จ.ต.(หญิง)',
  },
  {
    value: '3',
    label: 'จ.ท.',
  },
  {
    value: '4',
    label: 'จ.ท.(หญิง)',
  },
  {
    value: '5',
    label: 'จ.ส.ต.',
  },
  {
    value: '6',
    label: 'จ.ส.ต.(หญิง)',
  },
  {
    value: '7',
    label: 'จ.ส.ท.',
  },
  {
    value: '8',
    label: 'จ.ส.อ.',
  },
  {
    value: '9',
    label: 'จ.ส.อ.(หญิง)',
  },
  {
    value: '10',
    label: 'จ.อ.',
  },
  {
    value: '11',
    label: 'จ.อ.(หญิง)',
  },
  {
    value: '12',
    label: 'ด.ต.',
  },
  {
    value: '13',
    label: 'ด.ต.(หญิง)',
  },
  {
    value: '14',
    label: 'ดร.',
  },
  {
    value: '15',
    label: 'น.ต.',
  },
  {
    value: '16',
    label: 'น.ท.',
  },
  {
    value: '17',
    label: 'น.ท.(หญิง)',
  },
  {
    value: '18',
    label: 'น.พ.',
  },
  {
    value: '19',
    label: 'น.อ.',
  },
  {
    value: '20',
    label: 'น.อ.(พิเศษ)',
  },
  {
    value: '21',
    label: 'น.อ.อ.(พิเศษ)',
  },
  {
    value: '22',
    label: 'ผศ.ดร.',
  },
  {
    value: '23',
    label: 'พ.จ.ต.',
  },
  {
    value: '24',
    label: 'พ.จ.ท.',
  },
  {
    value: '25',
    label: 'พ.จ.อ.',
  },
  {
    value: '26',
    label: 'พ.จ.อ.(หญิง)',
  },
  {
    value: '27',
    label: 'พ.ญ.',
  },
  {
    value: '28',
    label: 'พ.ต.',
  },
  {
    value: '29',
    label: 'พ.ต.(หญิง)',
  },
  {
    value: '30',
    label: 'พ.ต.ต.',
  },
  {
    value: '31',
    label: 'พ.ต.ต.(หญิง)',
  },
  {
    value: '32',
    label: 'พ.ต.ท.',
  },
  {
    value: '33',
    label: 'พ.ต.ท.(หญิง)',
  },
  {
    value: '34',
    label: 'พ.ต.อ.',
  },
  {
    value: '35',
    label: 'พ.ต.อ.(พิเศษ)',
  },
  {
    value: '36',
    label: 'พ.ท.',
  },
  {
    value: '37',
    label: 'พ.ท.(หญิง)',
  },
  {
    value: '38',
    label: 'พ.อ.',
  },
  {
    value: '39',
    label: 'พ.อ.(พิเศษ)',
  },
  {
    value: '40',
    label: 'พ.อ.(หญิง)',
  },
  {
    value: '41',
    label: 'พ.อ.ต.',
  },
  {
    value: '42',
    label: 'พ.อ.ท.',
  },
  {
    value: '43',
    label: 'พ.อ.อ.',
  },
  {
    value: '44',
    label: 'พ.อ.อ.(หญิง)',
  },
  {
    value: '45',
    label: 'พล.จ.',
  },
  {
    value: '46',
    label: 'พล.ต.',
  },
  {
    value: '47',
    label: 'พล.ต.จ.',
  },
  {
    value: '48',
    label: 'พล.ต.ต.',
  },
  {
    value: '49',
    label: 'พล.ต.ท.',
  },
  {
    value: '50',
    label: 'พล.ต.อ.',
  },
  {
    value: '51',
    label: 'พล.ท.',
  },
  {
    value: '52',
    label: 'พล.ร.จ.',
  },
  {
    value: '53',
    label: 'พล.ร.ต.',
  },
  {
    value: '54',
    label: 'พล.ร.ท.',
  },
  {
    value: '55',
    label: 'พล.ร.อ.',
  },
  {
    value: '56',
    label: 'พล.อ.',
  },
  {
    value: '57',
    label: 'พล.อ.จ.',
  },
  {
    value: '58',
    label: 'พล.อ.ต.',
  },
  {
    value: '59',
    label: 'พล.อ.ต.(หญิง)',
  },
  {
    value: '60',
    label: 'พล.อ.ท.',
  },
  {
    value: '61',
    label: 'พล.อ.อ.',
  },
  {
    value: '62',
    label: 'พลฯ',
  },
  {
    value: '63',
    label: 'พลฯ(หญิง)',
  },
  {
    value: '64',
    label: 'ม.ร.ว.',
  },
  {
    value: '65',
    label: 'ม.ล.',
  },
  {
    value: '66',
    label: 'ร.ต.',
  },
  {
    value: '67',
    label: 'ร.ต.(หญิง)',
  },
  {
    value: '68',
    label: 'ร.ต.ต.',
  },
  {
    value: '69',
    label: 'ร.ต.ต.(หญิง)',
  },
  {
    value: '70',
    label: 'ร.ต.ท.',
  },
  {
    value: '71',
    label: 'ร.ต.ท.(หญิง)',
  },
  {
    value: '72',
    label: 'ร.ต.อ.',
  },
  {
    value: '73',
    label: 'ร.ต.อ.(หญิง)',
  },
  {
    value: '74',
    label: 'ร.ท.',
  },
  {
    value: '75',
    label: 'ร.ท.(หญิง)',
  },
  {
    value: '76',
    label: 'ร.น.',
  },
  {
    value: '77',
    label: 'ร.อ.',
  },
  {
    value: '78',
    label: 'ร.อ.(หญิง)',
  },
  {
    value: '79',
    label: 'ว่าที่ น.ต.',
  },
  {
    value: '80',
    label: 'ว่าที่ พ.ต.',
  },
  {
    value: '81',
    label: 'ว่าที่ พ.ต.ต.',
  },
  {
    value: '82',
    label: 'ว่าที่ ร.ต.',
  },
  {
    value: '83',
    label: 'ว่าที่ ร.ต.ต.',
  },
  {
    value: '84',
    label: 'ว่าที่ ร.ต.ท.',
  },
  {
    value: '85',
    label: 'ว่าที่ ร.ต.หญิง',
  },
  {
    value: '86',
    label: 'ว่าที่ ร.ต.อ.',
  },
  {
    value: '87',
    label: 'ว่าที่ ร.ท.',
  },
  {
    value: '88',
    label: 'ว่าที่ ร.อ.',
  },
  {
    value: '89',
    label: 'ศ.',
  },
  {
    value: '90',
    label: 'ส.ต.',
  },
  {
    value: '91',
    label: 'ส.ต.ต.',
  },
  {
    value: '92',
    label: 'ส.ต.ต.(หญิง)',
  },
  {
    value: '93',
    label: 'ส.ต.ท.',
  },
  {
    value: '94',
    label: 'ส.ต.ท.(หญิง)',
  },
  {
    value: '95',
    label: 'ส.ต.อ.',
  },
  {
    value: '96',
    label: 'ส.ท.',
  },
  {
    value: '97',
    label: 'ส.อ.',
  },
  {
    value: '98',
    label: 'ส.อ.(หญิง)',
  },
];

const rankingTypes = [
  {
    value: undefined,
    label: 'None',
  },
  {
    value: '1',
    label: '--1--',
  },
  {
    value: '2',
    label: '--2--',
  },
  {
    value: '3',
    label: '--3--',
  },
]

const eduClass = [
  {
    code: '',
    name: '-',
  },
  // {
  //   code: '10',
  //   name: 'อนุบาล',
  // },
  // {
  //   code: '12',
  //   name: 'ประถม',
  // },
  // {
  //   code: '13',
  //   name: 'มัธยมต้น',
  // },
  // {
  //   code: '14',
  //   name: 'มัธยมปลาย',
  // },
  {
    code: '65',
    name: 'ประถมศึกษา',
  },
  {
    code: '62',
    name: 'มัธยมศึกษา',
  },
  {
    code: '42',
    name: 'อนุปริญญา',
  },
  {
    code: '51',
    name: 'ปวช.',
  },
  {
    code: '41',
    name: 'ปวส.',
  },
  {
    code: '31',
    name: 'ปริญญาตรี',
  },
  {
    code: '21',
    name: 'ปริญญาโท',
  },
  {
    code: '11',
    name: 'ปริญญาเอก',
  },
];

const eduOnApplicant = [
  // {
  //   code: '',
  //   name: '-',
  // },
  {
    value: '65',
    label: 'ประถมศึกษา',
  },
  {
    value: '62',
    label: 'มัธยมศึกษา',
  },
  {
    value: '51',
    label: 'ปวช.',
  },
  {
    value: '42',
    label: 'อนุปริญญา',
  },
  {
    value: '41',
    label: 'ปวส.',
  },
  {
    value: '31',
    label: 'ปริญญาตรี',
  },
  {
    value: '21',
    label: 'ปริญญาโท',
  },
  {
    value: '11',
    label: 'ปริญญาเอก',
  },
];

const militaryStatusOptions = [
  // {
  //   code: '',
  //   name: '-',
  // },
  {
    value: '2',
    label: 'ยังไม่ได้เข้ารับการตรวจเลือกทหาร',
  },
  {
    value: '1',
    label: 'เข้ารับราชการทหารแล้ว',
  },
  {
    value: '3',
    label: 'ได้รับการยกเว้น (ไม่ใช่ผ่อนผัน) เนื่องจาก',
  },
  {
    value: '4',
    label: 'เรียน รด.',
  },
];

const maritalStatusOptions = [
  // {
  //   code: '',
  //   name: '-',
  // },
  {
    value: '0',
    label: 'โสด',
  },
  {
    value: '1',
    label: 'สมรส',
  },
  {
    value: '2',
    label: 'หม้าย',
  },
  {
    value: '3',
    label: 'หย่า',
  },
];

const positionTypeOptions = [
  // {
  //   code: '',
  //   name: '-',
  // },
  {
    value: '1',
    label: 'ส่วนกลาง',
  },
  {
    value: '2',
    label: 'ภูมิภาค',
  },
];

const computerSkillOptions = [
  {
    id: '1',
    name: 'Microsoft Office',
  },
  {
    id: '2',
    name: 'Network',
  },
  {
    id: '3',
    name: 'Hardware',
  },
  {
    id: '4',
    name: 'AutoCAD',
  },
  {
    id: '5',
    name: 'Sketch up',
  },
  {
    id: '6',
    name: 'Lumion',
  },
  {
    id: '7',
    name: 'SAP',
  },
  {
    id: '8',
    name: 'Mobile Application Developer',
  },
  {
    id: '9',
    name: 'Web Developer',
  },
  {
    id: '10',
    name: 'Graphics Software (เช่น Photoshop, Illustrator)',
  },
  {
    id: '11',
    name: 'CMS (เช่น Joomla, WordPress)',
  },
  {
    id: '12',
    name: 'Cloud computing',
  },
  {
    id: '13',
    name: 'Database (เช่น Oracle, MS SQL Server)',
  },
  {
    id: '14',
    name: 'SCADA',
  },
  {
    id: '15',
    name: 'Data Analytic',
  },
  {
    id: '16',
    name: 'อื่นๆ',
  },
];

const engineerCert = [
  {
    value: 'Y',
    label: 'มี',
  },
  {
    value: 'N',
    label: 'ไม่มี',
  },
];

const collegeActivityOptions = [
  {
    value: 'Y',
    label: 'มี',
  },
  {
    value: 'N',
    label: 'ไม่มี',
  },
];

const workExperienceOptions = [
  {
    value: 'Y',
    label: 'มีประสบการณ์ทำงาน',
  },
  {
    value: 'N',
    label: 'ไม่มีประสบการณ์ทำงาน',
  },
];

const engineerCertType = [
  // {
  //   code: '',
  //   name: '-',
  // },
  {
    value: '01',
    label: 'ภาคีวิศวกรพิเศษ',
  },
  {
    value: '02',
    label: 'ภาคีวิศวกร',
  },
  {
    value: '03',
    label: 'สามัญวิศวกร',
  },
  {
    value: '04',
    label: 'วุฒิวิศวกร',
  },
  {
    value: '05',
    label: 'ไม่ถือใบอนุญาต',
  },
  {
    value: '06',
    label: 'อาเซียน',
  },
  {
    value: '07',
    label: 'APEC',
  },
];

const engineerCertBranch = [
  // {
  //   code: '',
  //   name: '-',
  // },
  {
    value: '602',
    label: 'วิศวกรรมโยธา',
  },
  {
    value: '621',
    label: 'วิศวกรรมเหมืองแร่',
  },
  {
    value: '576',
    label: 'วิศวกรรมเครื่องกล',
  },
  {
    value: '592',
    label: 'วิศวกรรมไฟฟ้า',
  },
  {
    value: '629',
    label: 'วิศวกรรมอุตสาหการ',
  },
  {
    value: '616',
    label: 'วิศวกรรมสิ่งแวดล้อม',
  },
  {
    value: '575',
    label: 'วิศวกรรมเคมี',
  },
];

const languageSkill = [
  // {
  //   value: undefined,
  //   label: '-',
  // },
  // {
  //   value: '1',
  //   label: 'ดีมาก',
  // },
  // {
  //   value: '2',
  //   label: 'ดี',
  // },
  // {
  //   value: '3',
  //   label: 'พอใช้',
  // },
  {
    value: '1',
    label: 'พอใช้',
  },
  {
    value: '2',
    label: 'ปานกลาง',
  },
  {
    value: '3',
    label: 'ดี',
  },
  {
    value: '4',
    label: 'ดีมาก',
  },
];

const titleOptions = [
  // {
  //   value: undefined,
  //   label: '-',
  // },
  {
    value: 1,
    label: 'นาย',
  },
  {
    value: 2,
    label: 'นาง',
  },
  {
    value: 3,
    label: 'นางสาว',
  },
];

// const languageCertificate = [
//   {
//     value: undefined,
//     name: '',
//   },
//   {
//     value: '1',
//     name: 'TOEIC',
//   },
//   {
//     value: '2',
//     name: 'TOEFL',
//   },
// ];

const isMainEducationOptions = [
  {
    id: '1',
    name: 'วุฒิแรกเข้า',
  },
];

const isActAsDeputyOptions = [
  {
    id: '1',
    name: 'ทำการแทน รวธ.',
  },
];

const acceptAgreementOptions = [
  {
    id: '1',
    name: 'รับทราบและยินยอมให้ใช้ข้อมูลทำหลักฐานประกอบการจ้าง และบัตรประจำตัวลูกจ้างทดลองงาน',
  },
];

const acceptConsentOptions = [
  {
    id: 'Y',
    name: 'ยินยอม',
  },
  {
    id: 'N',
    name: 'ไม่ยินยอม',
  },
];

const languageCertificate = [
  '-',
  'TOEIC',
  'TOEFL',
  'IELTS',
  'TU-GET',
  'CU-TEP',
  'คะแนนภาษาอังกฤษ กฟผ.',
];

const honorsOptions = [
  {
    value: '01',
    name: 'เกียรตินิยมอันดับ 1',
  },
  {
    value: '02',
    name: 'เกียรตินิยมอันดับ 2',
  },
  {
    value: '03',
    name: 'เกียรตินิยมดีมาก',
  },
  {
    value: '04',
    name: 'เกียรตินิยมดี',
  },
  {
    value: '05',
    name: 'เกียรตินิยม',
  },
  {
    value: '',
    name: 'ไม่มี',
  },
];

const psAreaOptions = [
  {
    value: '01',
    label: 'ชง.นก.ง.พขร. พร. รป.',
  },
  {
    value: '02',
    label: 'พขก.',
  },
  {
    value: '03',
    label: 'ปวช.',
  },
  {
    value: '04',
    label: 'ปวส.',
  },
  {
    value: '05',
    label: 'ป.ตรี 4 ปี/เทียบเท่า',
  },
  {
    value: '06',
    label: 'ป.ตรี 5 ปี/เทียบเท่า',
  },
  {
    value: '07',
    label: 'ป.ทันต/แพทยฯ ใบ ว.',
  },
  {
    value: '08',
    label: 'ป.ตรี วิศวกรรมศาสตร์',
  },
  {
    value: '09',
    label: 'ป.โท ต่อ ป.ตรี 4 ปี',
  },
  {
    value: '10',
    label: 'ป.โท ต่อ ป.ตรี 5 ปี',
  },
  {
    value: '11',
    label: 'ป.โท วิศวกรรมศาสตร์',
  },
  {
    value: '12',
    label: 'ป.เอก',
  },
  {
    value: '13',
    label: 'ป.เอก วิศวกรรมศาสตร์',
  },
  {
    value: '14',
    label: 'ป.ตรี 6 ปี/เทียบเท่า',
  },
  {
    value: '15',
    label: 'ป.แพทยฯ ใบว.เฉพาะทาง',
  },
  {
    value: '16',
    label: 'ตำแหน่งนักบิน',
  },
];

const psGroupByArea = [
  {
    psArea: '01',
    psGroup: '01',
  },
  {
    psArea: '02',
    psGroup: '01',
  },
  {
    psArea: '03',
    psGroup: '02',
  },
  {
    psArea: '04',
    psGroup: '03',
  },
  {
    psArea: '05',
    psGroup: '04',
  },
  {
    psArea: '06',
    psGroup: '04',
  },
  {
    psArea: '07',
    psGroup: '04',
  },
  {
    psArea: '07',
    psGroup: '05',
  },
  {
    psArea: '08',
    psGroup: '04',
  },
  {
    psArea: '09',
    psGroup: '05',
  },
  {
    psArea: '10',
    psGroup: '05',
  },
  {
    psArea: '11',
    psGroup: '05',
  },
  {
    psArea: '12',
    psGroup: '06',
  },
  {
    psArea: '13',
    psGroup: '06',
  },
  {
    psArea: '14',
    psGroup: '04',
  },
  {
    psArea: '15',
    psGroup: '06',
  },
  {
    psArea: '16',
    psGroup: '06',
  },
];

const amount = [
  {
    psArea: '01',
    psGroup: '01',
    amount: 14000.0,
  },
  {
    psArea: '02',
    psGroup: '01',
    amount: 14000.0,
  },
  {
    psArea: '03',
    psGroup: '02',
    amount: 15800.0,
  },
  {
    psArea: '04',
    psGroup: '03',
    amount: 17600.0,
  },
  {
    psArea: '05',
    psGroup: '04',
    amount: 21800.0,
  },
  {
    psArea: '06',
    psGroup: '04',
    amount: 24900.0,
  },
  {
    psArea: '07',
    psGroup: '04',
    amount: 38800.0,
  },
  {
    psArea: '07',
    psGroup: '05',
    amount: 38800.0,
  },
  {
    psArea: '08',
    psGroup: '04',
    amount: 26400.0,
  },
  {
    psArea: '09',
    psGroup: '05',
    amount: 25500.0,
  },
  {
    psArea: '10',
    psGroup: '05',
    amount: 25500.0,
  },
  {
    psArea: '11',
    psGroup: '05',
    amount: 30800.0,
  },
  {
    psArea: '12',
    psGroup: '06',
    amount: 41000.0,
  },
  {
    psArea: '13',
    psGroup: '06',
    amount: 45000.0,
  },
  {
    psArea: '14',
    psGroup: '04',
    amount: 27600.0,
  },
  {
    psArea: '15',
    psGroup: '06',
    amount: 44800.0,
  },
  {
    psArea: '16',
    psGroup: '06',
    amount: 36300.0,
  },
];

const royalRankTypeOptions = [
  {
    id: '1',
    value: 'AIRFORCE',
    label: 'ทหารอากาศ',
  },
  {
    id: '2',
    value: 'ARMY',
    label: 'ทหารบก',
  },
  {
    id: '3',
    value: 'NAVY',
    label: 'ทหารเรือ',
  },
  {
    id: '4',
    value: 'POLICE',
    label: 'ตำรวจ',
  },
  {
    id: '5',
    value: 'OTHER',
    label: 'อื่นๆ',
  },
];

const royalRank = [
  {
    value: '1',
    label: 'จ.ต.',
  },
  {
    value: '2',
    label: 'จ.ต.(หญิง)',
  },
  {
    value: '3',
    label: 'จ.ท.',
  },
  {
    value: '4',
    label: 'จ.ท.(หญิง)',
  },
  {
    value: '5',
    label: 'จ.ส.ต.',
  },
  {
    value: '6',
    label: 'จ.ส.ต.(หญิง)',
  },
  {
    value: '7',
    label: 'จ.ส.ท.',
  },
  {
    value: '8',
    label: 'จ.ส.อ.',
  },
  {
    value: '9',
    label: 'จ.ส.อ.(หญิง)',
  },
  {
    value: '10',
    label: 'จ.อ.',
  },
  {
    value: '11',
    label: 'จ.อ.(หญิง)',
  },
  {
    value: '12',
    label: 'ด.ต.',
  },
  {
    value: '13',
    label: 'ด.ต.(หญิง)',
  },
  {
    value: '14',
    label: 'ดร.',
  },
  {
    value: '15',
    label: 'น.ต.',
  },
  {
    value: '16',
    label: 'น.ท.',
  },
  {
    value: '17',
    label: 'น.ท.(หญิง)',
  },
  {
    value: '18',
    label: 'น.พ.',
  },
  {
    value: '19',
    label: 'น.อ.',
  },
  {
    value: '20',
    label: 'น.อ.(พิเศษ)',
  },
  {
    value: '21',
    label: 'น.อ.อ.(พิเศษ)',
  },
  {
    value: '22',
    label: 'ผศ.ดร.',
  },
  {
    value: '23',
    label: 'พ.จ.ต.',
  },
  {
    value: '24',
    label: 'พ.จ.ท.',
  },
  {
    value: '25',
    label: 'พ.จ.อ.',
  },
  {
    value: '26',
    label: 'พ.จ.อ.(หญิง)',
  },
  {
    value: '27',
    label: 'พ.ญ.',
  },
  {
    value: '28',
    label: 'พ.ต.',
  },
  {
    value: '29',
    label: 'พ.ต.(หญิง)',
  },
  {
    value: '30',
    label: 'พ.ต.ต.',
  },
  {
    value: '31',
    label: 'พ.ต.ต.(หญิง)',
  },
  {
    value: '32',
    label: 'พ.ต.ท.',
  },
  {
    value: '33',
    label: 'พ.ต.ท.(หญิง)',
  },
  {
    value: '34',
    label: 'พ.ต.อ.',
  },
  {
    value: '35',
    label: 'พ.ต.อ.(พิเศษ)',
  },
  {
    value: '36',
    label: 'พ.ท.',
  },
  {
    value: '37',
    label: 'พ.ท.(หญิง)',
  },
  {
    value: '38',
    label: 'พ.อ.',
  },
  {
    value: '39',
    label: 'พ.อ.(พิเศษ)',
  },
  {
    value: '40',
    label: 'พ.อ.(หญิง)',
  },
  {
    value: '41',
    label: 'พ.อ.ต.',
  },
  {
    value: '42',
    label: 'พ.อ.ท.',
  },
  {
    value: '43',
    label: 'พ.อ.อ.',
  },
  {
    value: '44',
    label: 'พ.อ.อ.(หญิง)',
  },
  {
    value: '45',
    label: 'พล.จ.',
  },
  {
    value: '46',
    label: 'พล.ต.',
  },
  {
    value: '47',
    label: 'พล.ต.จ.',
  },
  {
    value: '48',
    label: 'พล.ต.ต.',
  },
  {
    value: '49',
    label: 'พล.ต.ท.',
  },
  {
    value: '50',
    label: 'พล.ต.อ.',
  },
  {
    value: '51',
    label: 'พล.ท.',
  },
  {
    value: '52',
    label: 'พล.ร.จ.',
  },
  {
    value: '53',
    label: 'พล.ร.ต.',
  },
  {
    value: '54',
    label: 'พล.ร.ท.',
  },
  {
    value: '55',
    label: 'พล.ร.อ.',
  },
  {
    value: '56',
    label: 'พล.อ.',
  },
  {
    value: '57',
    label: 'พล.อ.จ.',
  },
  {
    value: '58',
    label: 'พล.อ.ต.',
  },
  {
    value: '59',
    label: 'พล.อ.ต.(หญิง)',
  },
  {
    value: '60',
    label: 'พล.อ.ท.',
  },
  {
    value: '61',
    label: 'พล.อ.อ.',
  },
  {
    value: '62',
    label: 'พลฯ',
  },
  {
    value: '63',
    label: 'พลฯ(หญิง)',
  },
  {
    value: '64',
    label: 'ม.ร.ว.',
  },
  {
    value: '65',
    label: 'ม.ล.',
  },
  {
    value: '66',
    label: 'ร.ต.',
  },
  {
    value: '67',
    label: 'ร.ต.(หญิง)',
  },
  {
    value: '68',
    label: 'ร.ต.ต.',
  },
  {
    value: '69',
    label: 'ร.ต.ต.(หญิง)',
  },
  {
    value: '70',
    label: 'ร.ต.ท.',
  },
  {
    value: '71',
    label: 'ร.ต.ท.(หญิง)',
  },
  {
    value: '72',
    label: 'ร.ต.อ.',
  },
  {
    value: '73',
    label: 'ร.ต.อ.(หญิง)',
  },
  {
    value: '74',
    label: 'ร.ท.',
  },
  {
    value: '75',
    label: 'ร.ท.(หญิง)',
  },
  {
    value: '76',
    label: 'ร.อ.',
  },
  {
    value: '77',
    label: 'ร.อ.(หญิง)',
  },
  {
    value: '78',
    label: 'ว่าที่ น.ต.',
  },
  {
    value: '79',
    label: 'ว่าที่ พ.ต.',
  },
  {
    value: '80',
    label: 'ว่าที่ พ.ต.ต.',
  },
  {
    value: '81',
    label: 'ว่าที่ ร.ต.',
  },
  {
    value: '82',
    label: 'ว่าที่ ร.ต.ต.',
  },
  {
    value: '83',
    label: 'ว่าที่ ร.ต.ท.',
  },
  {
    value: '84',
    label: 'ว่าที่ ร.ต.หญิง',
  },
  {
    value: '85',
    label: 'ว่าที่ ร.ต.อ.',
  },
  {
    value: '86',
    label: 'ว่าที่ ร.ท.',
  },
  {
    value: '87',
    label: 'ว่าที่ ร.อ.',
  },
  {
    value: '88',
    label: 'ศ.',
  },
  {
    value: '89',
    label: 'ส.ต.',
  },
  {
    value: '90',
    label: 'ส.ต.ต.',
  },
  {
    value: '91',
    label: 'ส.ต.ต.(หญิง)',
  },
  {
    value: '92',
    label: 'ส.ต.ท.',
  },
  {
    value: '93',
    label: 'ส.ต.ท.(หญิง)',
  },
  {
    value: '94',
    label: 'ส.ต.อ.',
  },
  {
    value: '95',
    label: 'ส.ท.',
  },
  {
    value: '96',
    label: 'ส.อ.',
  },
  {
    value: '97',
    label: 'ส.อ.(หญิง)',
  },
];

const royalRankMap = [
  { royalRankId: '1', royalRankTypeId: '1' },
  { royalRankId: '1', royalRankTypeId: '3' },
  { royalRankId: '2', royalRankTypeId: '1' },
  { royalRankId: '2', royalRankTypeId: '3' },
  { royalRankId: '3', royalRankTypeId: '1' },
  { royalRankId: '3', royalRankTypeId: '3' },
  { royalRankId: '4', royalRankTypeId: '1' },
  { royalRankId: '4', royalRankTypeId: '3' },
  { royalRankId: '5', royalRankTypeId: '2' },
  { royalRankId: '5', royalRankTypeId: '4' },
  { royalRankId: '6', royalRankTypeId: '2' },
  { royalRankId: '6', royalRankTypeId: '4' },
  { royalRankId: '7', royalRankTypeId: '2' },
  { royalRankId: '8', royalRankTypeId: '2' },
  { royalRankId: '9', royalRankTypeId: '2' },
  { royalRankId: '10', royalRankTypeId: '1' },
  { royalRankId: '10', royalRankTypeId: '3' },
  { royalRankId: '11', royalRankTypeId: '1' },
  { royalRankId: '11', royalRankTypeId: '3' },
  { royalRankId: '12', royalRankTypeId: '4' },
  { royalRankId: '13', royalRankTypeId: '4' },
  { royalRankId: '14', royalRankTypeId: '5' },
  { royalRankId: '15', royalRankTypeId: '1' },
  { royalRankId: '15', royalRankTypeId: '3' },
  { royalRankId: '16', royalRankTypeId: '1' },
  { royalRankId: '16', royalRankTypeId: '3' },
  { royalRankId: '17', royalRankTypeId: '3' },
  { royalRankId: '18', royalRankTypeId: '5' },
  { royalRankId: '19', royalRankTypeId: '1' },
  { royalRankId: '19', royalRankTypeId: '3' },
  { royalRankId: '20', royalRankTypeId: '3' },
  { royalRankId: '21', royalRankTypeId: '1' },
  { royalRankId: '22', royalRankTypeId: '5' },
  { royalRankId: '23', royalRankTypeId: '3' },
  { royalRankId: '24', royalRankTypeId: '3' },
  { royalRankId: '25', royalRankTypeId: '3' },
  { royalRankId: '26', royalRankTypeId: '3' },
  { royalRankId: '27', royalRankTypeId: '5' },
  { royalRankId: '28', royalRankTypeId: '2' },
  { royalRankId: '29', royalRankTypeId: '2' },
  { royalRankId: '30', royalRankTypeId: '4' },
  { royalRankId: '31', royalRankTypeId: '4' },
  { royalRankId: '32', royalRankTypeId: '4' },
  { royalRankId: '33', royalRankTypeId: '4' },
  { royalRankId: '34', royalRankTypeId: '4' },
  { royalRankId: '35', royalRankTypeId: '4' },
  { royalRankId: '36', royalRankTypeId: '2' },
  { royalRankId: '37', royalRankTypeId: '2' },
  { royalRankId: '38', royalRankTypeId: '2' },
  { royalRankId: '39', royalRankTypeId: '2' },
  { royalRankId: '40', royalRankTypeId: '2' },
  { royalRankId: '41', royalRankTypeId: '1' },
  { royalRankId: '42', royalRankTypeId: '1' },
  { royalRankId: '43', royalRankTypeId: '1' },
  { royalRankId: '44', royalRankTypeId: '1' },
  { royalRankId: '45', royalRankTypeId: '2' },
  { royalRankId: '46', royalRankTypeId: '2' },
  { royalRankId: '47', royalRankTypeId: '4' },
  { royalRankId: '48', royalRankTypeId: '4' },
  { royalRankId: '49', royalRankTypeId: '4' },
  { royalRankId: '50', royalRankTypeId: '4' },
  { royalRankId: '51', royalRankTypeId: '2' },
  { royalRankId: '52', royalRankTypeId: '3' },
  { royalRankId: '53', royalRankTypeId: '3' },
  { royalRankId: '54', royalRankTypeId: '3' },
  { royalRankId: '55', royalRankTypeId: '3' },
  { royalRankId: '56', royalRankTypeId: '2' },
  { royalRankId: '57', royalRankTypeId: '1' },
  { royalRankId: '58', royalRankTypeId: '1' },
  { royalRankId: '59', royalRankTypeId: '1' },
  { royalRankId: '60', royalRankTypeId: '1' },
  { royalRankId: '61', royalRankTypeId: '1' },
  { royalRankId: '62', royalRankTypeId: '1' },
  { royalRankId: '62', royalRankTypeId: '2' },
  { royalRankId: '62', royalRankTypeId: '3' },
  { royalRankId: '63', royalRankTypeId: '1' },
  { royalRankId: '63', royalRankTypeId: '3' },
  { royalRankId: '64', royalRankTypeId: '5' },
  { royalRankId: '65', royalRankTypeId: '5' },
  { royalRankId: '66', royalRankTypeId: '1' },
  { royalRankId: '66', royalRankTypeId: '2' },
  { royalRankId: '66', royalRankTypeId: '3' },
  { royalRankId: '67', royalRankTypeId: '3' },
  { royalRankId: '68', royalRankTypeId: '4' },
  { royalRankId: '69', royalRankTypeId: '4' },
  { royalRankId: '70', royalRankTypeId: '4' },
  { royalRankId: '71', royalRankTypeId: '4' },
  { royalRankId: '72', royalRankTypeId: '4' },
  { royalRankId: '73', royalRankTypeId: '4' },
  { royalRankId: '74', royalRankTypeId: '1' },
  { royalRankId: '74', royalRankTypeId: '2' },
  { royalRankId: '74', royalRankTypeId: '3' },
  { royalRankId: '75', royalRankTypeId: '3' },
  { royalRankId: '76', royalRankTypeId: '1' },
  { royalRankId: '76', royalRankTypeId: '2' },
  { royalRankId: '76', royalRankTypeId: '3' },
  { royalRankId: '77', royalRankTypeId: '3' },
  { royalRankId: '78', royalRankTypeId: '1' },
  { royalRankId: '78', royalRankTypeId: '3' },
  { royalRankId: '79', royalRankTypeId: '2' },
  { royalRankId: '80', royalRankTypeId: '4' },
  { royalRankId: '81', royalRankTypeId: '1' },
  { royalRankId: '81', royalRankTypeId: '2' },
  { royalRankId: '81', royalRankTypeId: '3' },
  { royalRankId: '82', royalRankTypeId: '4' },
  { royalRankId: '83', royalRankTypeId: '4' },
  { royalRankId: '84', royalRankTypeId: '1' },
  { royalRankId: '84', royalRankTypeId: '2' },
  { royalRankId: '84', royalRankTypeId: '3' },
  { royalRankId: '85', royalRankTypeId: '4' },
  { royalRankId: '86', royalRankTypeId: '1' },
  { royalRankId: '86', royalRankTypeId: '2' },
  { royalRankId: '86', royalRankTypeId: '3' },
  { royalRankId: '87', royalRankTypeId: '1' },
  { royalRankId: '87', royalRankTypeId: '2' },
  { royalRankId: '87', royalRankTypeId: '3' },
  { royalRankId: '88', royalRankTypeId: '5' },
  { royalRankId: '89', royalRankTypeId: '2' },
  { royalRankId: '90', royalRankTypeId: '4' },
  { royalRankId: '91', royalRankTypeId: '4' },
  { royalRankId: '92', royalRankTypeId: '4' },
  { royalRankId: '93', royalRankTypeId: '4' },
  { royalRankId: '94', royalRankTypeId: '4' },
  { royalRankId: '95', royalRankTypeId: '2' },
  { royalRankId: '96', royalRankTypeId: '2' },
  { royalRankId: '97', royalRankTypeId: '2' },
];

const shortingPositions = [
  { value: 'ง.', label: 'คนงาน' },
  { value: 'ง.1', label: 'คนงาน 1' },
  { value: 'จขก.1', label: 'เจ้าหน้าที่ขับเครื่องจักรกลระดับ 1' },
  { value: 'จขก.2', label: 'เจ้าหน้าที่ขับเครื่องจักรกลระดับ 2' },
  { value: 'จขก.3', label: 'เจ้าหน้าที่ขับเครื่องจักรกลระดับ 3' },
  { value: 'จขร.1', label: 'เจ้าหน้าที่ขับรถบุคคลสำคัญระดับ 1' },
  { value: 'จขร.2', label: 'เจ้าหน้าที่ขับรถบุคคลสำคัญระดับ 2' },
  { value: 'จขร.3', label: 'เจ้าหน้าที่ขับรถบุคคลสำคัญระดับ 3' },
  { value: 'จบท.1', label: 'เจ้าหน้าที่บริการทั่วไประดับ 1' },
  { value: 'จบท.2', label: 'เจ้าหน้าที่บริการทั่วไประดับ 2' },
  { value: 'จบท.3', label: 'เจ้าหน้าที่บริการทั่วไประดับ 3' },
  { value: 'จร.1', label: 'เจ้าหน้าที่ขับเรือระดับ 1' },
  { value: 'จร.2', label: 'เจ้าหน้าที่ขับเรือระดับ 2' },
  { value: 'จร.3', label: 'เจ้าหน้าที่ขับเรือระดับ 3' },
  { value: 'จรป.1', label: 'เจ้าหน้าที่รักษาความปลอดภัยพื้นที่สำคัญระดับ 1' },
  { value: 'จรป.2', label: 'เจ้าหน้าที่รักษาความปลอดภัยพื้นที่สำคัญระดับ 2' },
  { value: 'จรป.3', label: 'เจ้าหน้าที่รักษาความปลอดภัยพื้นที่สำคัญระดับ 3' },
  { value: 'ช.', label: 'ช่าง' },
  { value: 'ช.1', label: 'ช่างระดับ 1' },
  { value: 'ช.10', label: 'ช่างระดับ 10' },
  { value: 'ช.11', label: 'ช่างระดับ 11' },
  { value: 'ช.2', label: 'ช่างระดับ 2' },
  { value: 'ช.3', label: 'ช่างระดับ 3' },
  { value: 'ช.4', label: 'ช่างระดับ 4' },
  { value: 'ช.5', label: 'ช่างระดับ 5' },
  { value: 'ช.6', label: 'ช่างระดับ 6' },
  { value: 'ช.7', label: 'ช่างระดับ 7' },
  { value: 'ช.8', label: 'ช่างระดับ 8' },
  { value: 'ช.9', label: 'ช่างระดับ 9' },
  { value: 'ชก.', label: 'ช่างชำนาญการ' },
  { value: 'ชก.3', label: 'ช่างชำนาญการ 3' },
  { value: 'ชก.4', label: 'ช่างชำนาญการ 4' },
  { value: 'ชง.', label: 'คนชำนาญงาน' },
  { value: 'ชง.1', label: 'คนชำนาญงานระดับ 1' },
  { value: 'ชง.2', label: 'คนชำนาญงานระดับ 2' },
  { value: 'ชช.1', label: 'ช่างเชื่อมระดับ 1' },
  { value: 'ชช.2', label: 'ช่างเชื่อมระดับ 2' },
  { value: 'ชช.3', label: 'ช่างเชื่อมระดับ 3' },
  { value: 'ชบ.1', label: 'ช่างบำรุงรักษาระดับ 1' },
  { value: 'ชบ.2', label: 'ช่างบำรุงรักษาระดับ 2' },
  { value: 'ชบ.3', label: 'ช่างบำรุงรักษาระดับ 3' },
  { value: 'ชม.1', label: 'ช่างปฏิบัติการเหมืองระดับ 1' },
  { value: 'ชม.2', label: 'ช่างปฏิบัติการเหมืองระดับ 2' },
  { value: 'ชม.3', label: 'ช่างปฏิบัติการเหมืองระดับ 3' },
  { value: 'ตส.10', label: 'ผู้ตรวจสอบภายในระดับ 10' },
  { value: 'ตส.11', label: 'ผู้ตรวจสอบภายในระดับ 11' },
  { value: 'ตส.12', label: 'ผู้ตรวจสอบภายในระดับ 12' },
  { value: 'ตส.13', label: 'ผู้ตรวจสอบภายในระดับ 13' },
  { value: 'ตส.14', label: 'ผู้ตรวจสอบภายในระดับ 14' },
  { value: 'ตส.4', label: 'ผู้ตรวจสอบภายในระดับ 4' },
  { value: 'ตส.5', label: 'ผู้ตรวจสอบภายในระดับ 5' },
  { value: 'ตส.6', label: 'ผู้ตรวจสอบภายในระดับ 6' },
  { value: 'ตส.7', label: 'ผู้ตรวจสอบภายในระดับ 7' },
  { value: 'ตส.8', label: 'ผู้ตรวจสอบภายในระดับ 8' },
  { value: 'ตส.9', label: 'ผู้ตรวจสอบภายในระดับ 9' },
  { value: 'ทพ.10', label: 'ทันตแพทย์ระดับ 10' },
  { value: 'ทพ.11', label: 'ทันตแพทย์ระดับ 11' },
  { value: 'ทพ.12', label: 'ทันตแพทย์ระดับ 12' },
  { value: 'ทพ.13', label: 'ทันตแพทย์ระดับ 13' },
  { value: 'ทพ.14', label: 'ทันตแพทย์ระดับ 14' },
  { value: 'ทพ.3', label: 'ทันตแพทย์ระดับ 3' },
  { value: 'ทพ.4', label: 'ทันตแพทย์ระดับ 4' },
  { value: 'ทพ.5', label: 'ทันตแพทย์ระดับ 5' },
  { value: 'ทพ.6', label: 'ทันตแพทย์ระดับ 6' },
  { value: 'ทพ.7', label: 'ทันตแพทย์ระดับ 7' },
  { value: 'ทพ.8', label: 'ทันตแพทย์ระดับ 8' },
  { value: 'ทพ.9', label: 'ทันตแพทย์ระดับ 9' },
  { value: 'นก.', label: 'นักการ' },
  { value: 'นก.1', label: 'นักการระดับ 1' },
  { value: 'นก.2', label: 'นักการระดับ 2' },
  { value: 'นค.10', label: 'นักคอมพิวเตอร์ระดับ 10' },
  { value: 'นค.11', label: 'นักคอมพิวเตอร์ระดับ 11' },
  { value: 'นค.12', label: 'นักคอมพิวเตอร์ระดับ 12' },
  { value: 'นค.13', label: 'นักคอมพิวเตอร์ระดับ 13' },
  { value: 'นค.14', label: 'นักคอมพิวเตอร์ระดับ 14' },
  { value: 'นค.4', label: 'นักคอมพิวเตอร์ระดับ 4' },
  { value: 'นค.5', label: 'นักคอมพิวเตอร์ระดับ 5' },
  { value: 'นค.6', label: 'นักคอมพิวเตอร์ระดับ 6' },
  { value: 'นค.7', label: 'นักคอมพิวเตอร์ระดับ 7' },
  { value: 'นค.8', label: 'นักคอมพิวเตอร์ระดับ 8' },
  { value: 'นค.9', label: 'นักคอมพิวเตอร์ระดับ 9' },
  { value: 'นต.10', label: 'นิติกรระดับ 10' },
  { value: 'นต.11', label: 'นิติกรระดับ 11' },
  { value: 'นต.12', label: 'นิติกรระดับ 12' },
  { value: 'นต.13', label: 'นิติกรระดับ 13' },
  { value: 'นต.14', label: 'นิติกรระดับ 14' },
  { value: 'นต.3', label: 'นิติกรระดับ 3' },
  { value: 'นต.4', label: 'นิติกรระดับ 4' },
  { value: 'นต.5', label: 'นิติกรระดับ 5' },
  { value: 'นต.6', label: 'นิติกรระดับ 6' },
  { value: 'นต.7', label: 'นิติกรระดับ 7' },
  { value: 'นต.8', label: 'นิติกรระดับ 8' },
  { value: 'นต.9', label: 'นิติกรระดับ 9' },
  { value: 'นธ.10', label: 'นักธรณีวิทยาระดับ 10' },
  { value: 'นธ.11', label: 'นักธรณีวิทยาระดับ 11' },
  { value: 'นธ.12', label: 'นักธรณีวิทยาระดับ 12' },
  { value: 'นธ.13', label: 'นักธรณีวิทยาระดับ 13' },
  { value: 'นธ.14', label: 'นักธรณีวิทยาระดับ 14' },
  { value: 'นธ.3', label: 'นักธรณีวิทยาระดับ 3' },
  { value: 'นธ.4', label: 'นักธรณีวิทยาระดับ 4' },
  { value: 'นธ.5', label: 'นักธรณีวิทยาระดับ 5' },
  { value: 'นธ.6', label: 'นักธรณีวิทยาระดับ 6' },
  { value: 'นธ.7', label: 'นักธรณีวิทยาระดับ 7' },
  { value: 'นธ.8', label: 'นักธรณีวิทยาระดับ 8' },
  { value: 'นธ.9', label: 'นักธรณีวิทยาระดับ 9' },
  { value: 'นบ.10', label: 'นักบินระดับ 10' },
  { value: 'นบ.11', label: 'นักบินระดับ 11' },
  { value: 'นบ.12', label: 'นักบินระดับ 12' },
  { value: 'นบ.13', label: 'นักบินระดับ 13' },
  { value: 'นบ.14', label: 'นักบินระดับ 14' },
  { value: 'นบ.3', label: 'นักบินระดับ 3' },
  { value: 'นบ.4', label: 'นักบินระดับ 4' },
  { value: 'นบ.5', label: 'นักบินระดับ 5' },
  { value: 'นบ.6', label: 'นักบินระดับ 6' },
  { value: 'นบ.7', label: 'นักบินระดับ 7' },
  { value: 'นบ.8', label: 'นักบินระดับ 8' },
  { value: 'นบ.9', label: 'นักบินระดับ 9' },
  { value: 'นพ.10', label: 'นายแพทย์ระดับ 10' },
  { value: 'นพ.11', label: 'นายแพทย์ระดับ 11' },
  { value: 'นพ.12', label: 'นายแพทย์ระดับ 12' },
  { value: 'นพ.13', label: 'นายแพทย์ระดับ 13' },
  { value: 'นพ.14', label: 'นายแพทย์ระดับ 14' },
  { value: 'นพ.3', label: 'นายแพทย์ระดับ 3' },
  { value: 'นพ.4', label: 'นายแพทย์ระดับ 4' },
  { value: 'นพ.5', label: 'นายแพทย์ระดับ 5' },
  { value: 'นพ.6', label: 'นายแพทย์ระดับ 6' },
  { value: 'นพ.7', label: 'นายแพทย์ระดับ 7' },
  { value: 'นพ.8', label: 'นายแพทย์ระดับ 8' },
  { value: 'นพ.9', label: 'นายแพทย์ระดับ 9' },
  { value: 'นร.10', label: 'นักเดินเรือระดับ 10' },
  { value: 'นร.11', label: 'นักเดินเรือระดับ 11' },
  { value: 'นร.12', label: 'นักเดินเรือระดับ 12' },
  { value: 'นร.13', label: 'นักเดินเรือระดับ 13' },
  { value: 'นร.14', label: 'นักเดินเรือระดับ 14' },
  { value: 'นร.4', label: 'นักเดินเรือระดับ 4' },
  { value: 'นร.5', label: 'นักเดินเรือระดับ 5' },
  { value: 'นร.6', label: 'นักเดินเรือระดับ 6' },
  { value: 'นร.7', label: 'นักเดินเรือระดับ 7' },
  { value: 'นร.8', label: 'นักเดินเรือระดับ 8' },
  { value: 'นร.9', label: 'นักเดินเรือระดับ 9' },
  { value: 'บช.', label: 'นักบัญชี' },
  { value: 'บช.10', label: 'นักบัญชีระดับ 10' },
  { value: 'บช.11', label: 'นักบัญชีระดับ 11' },
  { value: 'บช.12', label: 'นักบัญชีระดับ 12' },
  { value: 'บช.13', label: 'นักบัญชีระดับ 13' },
  { value: 'บช.14', label: 'นักบัญชีระดับ 14' },
  { value: 'บช.3', label: 'นักบัญชีระดับ 3' },
  { value: 'บช.4', label: 'นักบัญชีระดับ 4' },
  { value: 'บช.5', label: 'นักบัญชีระดับ 5' },
  { value: 'บช.6', label: 'นักบัญชีระดับ 6' },
  { value: 'บช.7', label: 'นักบัญชีระดับ 7' },
  { value: 'บช.8', label: 'นักบัญชีระดับ 8' },
  { value: 'บช.9', label: 'นักบัญชีระดับ 9' },
  { value: 'ปษ.13', label: 'ที่ปรึกษาระดับ 13' },
  { value: 'ปษ.14', label: 'ที่ปรึกษาระดับ 14' },
  { value: 'ผช.', label: 'ผู้เชี่ยวชาญ' },
  { value: 'ผช.12', label: 'ผู้เชี่ยวชาญระดับ 12' },
  { value: 'พ.', label: 'พยาบาล' },
  { value: 'พ.10', label: 'พยาบาลระดับ 10' },
  { value: 'พ.11', label: 'พยาบาลระดับ 11' },
  { value: 'พ.2', label: 'พยาบาลระดับ 2' },
  { value: 'พ.3', label: 'พยาบาลระดับ 3' },
  { value: 'พ.4', label: 'พยาบาลระดับ 4' },
  { value: 'พ.5', label: 'พยาบาลระดับ 5' },
  { value: 'พ.6', label: 'พยาบาลระดับ 6' },
  { value: 'พ.7', label: 'พยาบาลระดับ 7' },
  { value: 'พ.8', label: 'พยาบาลระดับ 8' },
  { value: 'พ.9', label: 'พยาบาลระดับ 9' },
  { value: 'พขก.', label: 'พนักงานขับเครื่องจักรกล' },
  { value: 'พขก.1', label: 'พนักงานขับเครื่องจักรกลระดับ 1' },
  { value: 'พขก.2', label: 'พนักงานขับเครื่องจักรกลระดับ 2' },
  { value: 'พขก.3', label: 'พนักงานขับเครื่องจักรกลระดับ 3' },
  { value: 'พขก.4', label: 'พนักงานขับเครื่องจักรกลระดับ 4' },
  { value: 'พขร.', label: 'พนักงานขับรถ' },
  { value: 'พขร.1', label: 'พนักงานขับรถระดับ 1' },
  { value: 'พขร.2', label: 'พนักงานขับรถระดับ 2' },
  { value: 'พขร.3', label: 'พนักงานขับรถระดับ 3' },
  { value: 'พช.', label: 'พนักงานวิชาชีพ' },
  { value: 'พช.10', label: 'พนักงานวิชาชีพระดับ 10' },
  { value: 'พช.11', label: 'พนักงานวิชาชีพระดับ 11' },
  { value: 'พช.2', label: 'พนักงานวิชาชีพระดับ 2' },
  { value: 'พช.3', label: 'พนักงานวิชาชีพระดับ 3' },
  { value: 'พช.4', label: 'พนักงานวิชาชีพระดับ 4' },
  { value: 'พช.5', label: 'พนักงานวิชาชีพระดับ 5' },
  { value: 'พช.6', label: 'พนักงานวิชาชีพระดับ 6' },
  { value: 'พช.7', label: 'พนักงานวิชาชีพระดับ 7' },
  { value: 'พช.8', label: 'พนักงานวิชาชีพระดับ 8' },
  { value: 'พช.9', label: 'พนักงานวิชาชีพระดับ 9' },
  { value: 'พธ.1', label: 'พนักงานธุรการระดับ 1' },
  { value: 'พธ.2', label: 'พนักงานธุรการระดับ 2' },
  { value: 'พธ.3', label: 'พนักงานธุรการระดับ 3' },
  { value: 'พธ.4', label: 'พนักงานธุรการระดับ 4' },
  { value: 'พบ.10', label: 'พยาบาลปริญญาระดับ 10' },
  { value: 'พบ.11', label: 'พยาบาลปริญญาระดับ 11' },
  { value: 'พบ.12', label: 'พยาบาลปริญญาระดับ 12' },
  { value: 'พบ.13', label: 'พยาบาลปริญญาระดับ 13' },
  { value: 'พบ.14', label: 'พยาบาลปริญญาระดับ 14' },
  { value: 'พบ.3', label: 'พยาบาลปริญญาระดับ 3' },
  { value: 'พบ.4', label: 'พยาบาลปริญญาระดับ 4' },
  { value: 'พบ.5', label: 'พยาบาลปริญญาระดับ 5' },
  { value: 'พบ.6', label: 'พยาบาลปริญญาระดับ 6' },
  { value: 'พบ.7', label: 'พยาบาลปริญญาระดับ 7' },
  { value: 'พบ.8', label: 'พยาบาลปริญญาระดับ 8' },
  { value: 'พบ.9', label: 'พยาบาลปริญญาระดับ 9' },
  { value: 'พร.', label: 'พนักงานขับเรือ' },
  { value: 'พร.1', label: 'พนักงานขับเรือระดับ 1' },
  { value: 'พร.2', label: 'พนักงานขับเรือระดับ 2' },
  { value: 'พร.3', label: 'พนักงานขับเรือระดับ 3' },
  { value: 'พรป.', label: 'หัวหน้าพนักงานรักษาความปลอดภัย' },
  { value: 'พรป.1', label: 'หัวหน้าพนักงานรักษาความปลอดภัยระดับ 1' },
  { value: 'พรป.2', label: 'หัวหน้าพนักงานรักษาความปลอดภัยระดับ 2' },
  { value: 'พรป.3', label: 'หัวหน้าพนักงานรักษาความปลอดภัยระดับ 3' },
  { value: 'พรป.4', label: 'หัวหน้าพนักงานรักษาความปลอดภัยระดับ 4' },
  { value: 'ภส.10', label: 'เภสัชกรระดับ 10' },
  { value: 'ภส.11', label: 'เภสัชกรระดับ 11' },
  { value: 'ภส.12', label: 'เภสัชกรระดับ 12' },
  { value: 'ภส.13', label: 'เภสัชกรระดับ 13' },
  { value: 'ภส.14', label: 'เภสัชกรระดับ 14' },
  { value: 'ภส.4', label: 'เภสัชกรระดับ 4' },
  { value: 'ภส.5', label: 'เภสัชกรระดับ 5' },
  { value: 'ภส.6', label: 'เภสัชกรระดับ 6' },
  { value: 'ภส.7', label: 'เภสัชกรระดับ 7' },
  { value: 'ภส.8', label: 'เภสัชกรระดับ 8' },
  { value: 'ภส.9', label: 'เภสัชกรระดับ 9' },
  { value: 'รป.', label: 'พนักงานรักษาความปลอดภัย' },
  { value: 'รป.1', label: 'พนักงานรักษาความปลอดภัยระดับ 1' },
  { value: 'รป.2', label: 'พนักงานรักษาความปลอดภัยระดับ 2' },
  { value: 'ลฌป.', label: 'ลูกจ้างฌาปนกิจ' },
  { value: 'วก.', label: 'วิทยากร' },
  { value: 'วก.10', label: 'วิทยากรระดับ 10' },
  { value: 'วก.11', label: 'วิทยากรระดับ 11' },
  { value: 'วก.12', label: 'วิทยากรระดับ 12' },
  { value: 'วก.13', label: 'วิทยากรระดับ 13' },
  { value: 'วก.14', label: 'วิทยากรระดับ 14' },
  { value: 'วก.3', label: 'วิทยากรระดับ 3' },
  { value: 'วก.4', label: 'วิทยากรระดับ 4' },
  { value: 'วก.5', label: 'วิทยากรระดับ 5' },
  { value: 'วก.6', label: 'วิทยากรระดับ 6' },
  { value: 'วก.7', label: 'วิทยากรระดับ 7' },
  { value: 'วก.8', label: 'วิทยากรระดับ 8' },
  { value: 'วก.9', label: 'วิทยากรระดับ 9' },
  { value: 'วท.10', label: 'นักวิทยาศาสตร์ระดับ 10' },
  { value: 'วท.11', label: 'นักวิทยาศาสตร์ระดับ 11' },
  { value: 'วท.12', label: 'นักวิทยาศาสตร์ระดับ 12' },
  { value: 'วท.13', label: 'นักวิทยาศาสตร์ระดับ 13' },
  { value: 'วท.14', label: 'นักวิทยาศาสตร์ระดับ 14' },
  { value: 'วท.3', label: 'นักวิทยาศาสตร์ระดับ 3' },
  { value: 'วท.4', label: 'นักวิทยาศาสตร์ระดับ 4' },
  { value: 'วท.5', label: 'นักวิทยาศาสตร์ระดับ 5' },
  { value: 'วท.6', label: 'นักวิทยาศาสตร์ระดับ 6' },
  { value: 'วท.7', label: 'นักวิทยาศาสตร์ระดับ 7' },
  { value: 'วท.8', label: 'นักวิทยาศาสตร์ระดับ 8' },
  { value: 'วท.9', label: 'นักวิทยาศาสตร์ระดับ 9' },
  { value: 'วพ.10', label: 'นักวิทยาศาสตร์การแพทย์ระดับ 10' },
  { value: 'วพ.11', label: 'นักวิทยาศาสตร์การแพทย์ระดับ 11' },
  { value: 'วพ.12', label: 'นักวิทยาศาสตร์การแพทย์ระดับ 12' },
  { value: 'วพ.13', label: 'นักวิทยาศาสตร์การแพทย์ระดับ 13' },
  { value: 'วพ.14', label: 'นักวิทยาศาสตร์การแพทย์ระดับ 14' },
  { value: 'วพ.3', label: 'นักวิทยาศาสตร์การแพทย์ระดับ 3' },
  { value: 'วพ.4', label: 'นักวิทยาศาสตร์การแพทย์ระดับ 4' },
  { value: 'วพ.5', label: 'นักวิทยาศาสตร์การแพทย์ระดับ 5' },
  { value: 'วพ.6', label: 'นักวิทยาศาสตร์การแพทย์ระดับ 6' },
  { value: 'วพ.7', label: 'นักวิทยาศาสตร์การแพทย์ระดับ 7' },
  { value: 'วพ.8', label: 'นักวิทยาศาสตร์การแพทย์ระดับ 8' },
  { value: 'วพ.9', label: 'นักวิทยาศาสตร์การแพทย์ระดับ 9' },
  { value: 'วศ.', label: 'วิศวกร' },
  { value: 'วศ.10', label: 'วิศวกรระดับ 10' },
  { value: 'วศ.11', label: 'วิศวกรระดับ 11' },
  { value: 'วศ.12', label: 'วิศวกรระดับ 12' },
  { value: 'วศ.13', label: 'วิศวกรระดับ 13' },
  { value: 'วศ.14', label: 'วิศวกรระดับ 14' },
  { value: 'วศ.3', label: 'วิศวกรระดับ 3' },
  { value: 'วศ.4', label: 'วิศวกรระดับ 4' },
  { value: 'วศ.5', label: 'วิศวกรระดับ 5' },
  { value: 'วศ.6', label: 'วิศวกรระดับ 6' },
  { value: 'วศ.7', label: 'วิศวกรระดับ 7' },
  { value: 'วศ.8', label: 'วิศวกรระดับ 8' },
  { value: 'วศ.9', label: 'วิศวกรระดับ 9' },
  { value: 'ศก.10', label: 'เศรษฐกรระดับ 10' },
  { value: 'ศก.11', label: 'เศรษฐกรระดับ 11' },
  { value: 'ศก.12', label: 'เศรษฐกรระดับ 12' },
  { value: 'ศก.13', label: 'เศรษฐกรระดับ 13' },
  { value: 'ศก.14', label: 'เศรษฐกรระดับ 14' },
  { value: 'ศก.3', label: 'เศรษฐกรระดับ 3' },
  { value: 'ศก.4', label: 'เศรษฐกรระดับ 4' },
  { value: 'ศก.5', label: 'เศรษฐกรระดับ 5' },
  { value: 'ศก.6', label: 'เศรษฐกรระดับ 6' },
  { value: 'ศก.7', label: 'เศรษฐกรระดับ 7' },
  { value: 'ศก.8', label: 'เศรษฐกรระดับ 8' },
  { value: 'ศก.9', label: 'เศรษฐกรระดับ 9' },
  { value: 'สถ.10', label: 'สถาปนิกระดับ 10' },
  { value: 'สถ.11', label: 'สถาปนิกระดับ 11' },
  { value: 'สถ.12', label: 'สถาปนิกระดับ 12' },
  { value: 'สถ.13', label: 'สถาปนิกระดับ 13' },
  { value: 'สถ.14', label: 'สถาปนิกระดับ 14' },
  { value: 'สถ.3', label: 'สถาปนิกระดับ 3' },
  { value: 'สถ.4', label: 'สถาปนิกระดับ 4' },
  { value: 'สถ.5', label: 'สถาปนิกระดับ 5' },
  { value: 'สถ.6', label: 'สถาปนิกระดับ 6' },
  { value: 'สถ.7', label: 'สถาปนิกระดับ 7' },
  { value: 'สถ.8', label: 'สถาปนิกระดับ 8' },
  { value: 'สถ.9', label: 'สถาปนิกระดับ 9' },
];

//หัวหน้ากองสรรหาและงานบุคคล
const hrChief = {empNo: '564745', empName: 'นายธรรมสร ปริวัฒนศักดิ์', position: "หัวหน้ากองสรรหาและงานบุคคล"};


// Helper function to get filtered royal ranks by type
const getFilteredRoyalRanks = (royalRankTypeId) => {
  if (!royalRankTypeId) return royalRank;

  // Filter royalRankMap by royalRankTypeId and create a Set for faster lookup
  const filteredIdsSet = new Set(
    royalRankMap
      .filter((item) => item.royalRankTypeId === royalRankTypeId)
      .map((item) => item.royalRankId)
  );

  // Filter royal ranks using Set for O(1) lookup
  return royalRank.filter((rank) => filteredIdsSet.has(rank.value));
};

export default {
  positionTypeOptions,
  titleOptions,
  rankingPositions,
  rankingTypes,
  eduClass,
  eduOnApplicant,
  engineerCert,
  collegeActivityOptions,
  engineerCertType,
  engineerCertBranch,
  languageSkill,
  languageCertificate,
  workExperienceOptions,
  computerSkillOptions,
  militaryStatusOptions,
  maritalStatusOptions,
  acceptAgreementOptions,
  acceptConsentOptions,
  isMainEducationOptions,
  isActAsDeputyOptions,
  honorsOptions,
  psAreaOptions,
  psGroupByArea,
  amount,
  royalRank,
  royalRankTypeOptions,
  royalRankMap,
  getFilteredRoyalRanks,
  shortingPositions,
  hrChief
};
